import {
  CONNECTION_DEFAULT_ORDERING,
  CONNECTION_DEFAULT_SORT_BY,
  CONNECTION_DEFAULT_SORT_DIRECTION,
} from './constants';

export * from './ConnectionRequestsFilters';
export * from './models';
export * from './constants';

export const defaultFilter = {
  search: '',
  facility: [],
  specialties: [],
  opportunity: [],
  statusCategory: '',
  sortBy: CONNECTION_DEFAULT_SORT_BY,
  sortDirection: CONNECTION_DEFAULT_SORT_DIRECTION,
  ordering: CONNECTION_DEFAULT_ORDERING,
};
